import Vue from 'vue'
import Plugin from './plugin'

const OTHER_STATUS = 999

// 401 正在處理中(整頁重載或提示重新登入)。同一頁的多個請求會一起收到 401,
// 這個旗標確保只處理一次,不會重載兩次或連跳好幾個 alert。
// 頁面重載後模組重新初始化,旗標自然歸零。
let reauthenticating = false

class ErrorHandler {
  constructor () {
    this.handlers = {}
  }

  _defaultHandlers () {
    return {
      // 401 代表 session 已經不在了(閒置逾時、CAS 換過 session、節點切換)。
      //
      // CAS 的 sendRenew 是 false,TGT 還有效時只要用「整頁請求」走一次 CAS 就會自動換到新 session
      // 並導回來,客人不必重新登入、也不必另開頁簽;TGT 真的過期才會停在 CAS 登入頁,那是正確行為。
      // 這一步得由前端補:帶 X-Requested-With 的 AJAX 走的是 ajaxAuthenticationEntryPoint,
      // 只會拿到 401,不會被導去 CAS。
      //
      // 防連環重載:重載後短時間內又收到 401,代表這條路救不回來(例如該 API 本來就需要更高權限),
      // 就退回原本的提示,不要把客人卡在重載迴圈裡。
      401: (vm, response) => {
        const REAUTH_KEY = 'payeasy-reauth-at'
        const REAUTH_WINDOW = 30000

        if (reauthenticating) {
          return
        }

        reauthenticating = true

        let promptRelogin = () => {
          window.alert('登入逾時，請重新登入')
          window.location.href = 'https://www.payeasy.com.tw/TravelShop/hotel/#/main'
        }

        try {
          let lastAttempt = Number(window.sessionStorage.getItem(REAUTH_KEY) || 0)

          if (Date.now() - lastAttempt < REAUTH_WINDOW) {
            window.sessionStorage.removeItem(REAUTH_KEY)
            promptRelogin()
            return
          }

          window.sessionStorage.setItem(REAUTH_KEY, String(Date.now()))
        } catch (e) {
          // 無痕視窗或封鎖 storage 時讀寫會拋錯;沒有防護就不做自動重載,免得陷入迴圈
          promptRelogin()
          return
        }

        window.location.reload()
      },
      500: (vm, response) => {
        vm.$router.push('/500')
      },
      503: (vm, response) => {
        window.alert('旅遊系統正在維護中，請稍後再試')
        window.location.href = 'http://www.payeasy.com.tw'
      }
    }
  }

  _getHandler (status, useDefault) {
    let handler = this.handlers[status]

    if (handler) {
      return handler
    }

    let otherHandler = this.handlers[OTHER_STATUS]

    if (otherHandler) {
      return otherHandler
    }

    return useDefault
      ? (this._defaultHandlers()[status]) || this._defaultHandlers()[500]
      : this._defaultHandlers()[500]
  }

  status (status, handler) {
    this.handlers[status] = handler
    return this
  }

  otherStatus (handler) {
    if (this.handlers[OTHER_STATUS]) {
      throw new Error(`You can't call otherStatus twice`)
    }

    this.handlers[OTHER_STATUS] = handler
    return this
  }

  getDefaultHandler (status) {
    let defaultHandler = this._defaultHandlers()[status]
    if (defaultHandler) {
      return defaultHandler
    } else {
      throw new Error(`Can't find defaultHandler with status[${status}]`)
    }
  }

  handle (vm, response, useDefault = true) {
    if (process.env.NODE_ENV !== 'production') {
      console.log('errorHandler.handle(response)', response)
    }

    this._getHandler(response.data.status, useDefault)(vm, response)
  }
}

Vue.use(Plugin, ErrorHandler)



// WEBPACK FOOTER //
// ./src/configs/error-handler/index.js